import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'

    const cryptoApiHeaders = {
        'x-rapidapi-host': 'coinranking1.p.rapidapi.com',
        'x-rapidapi-key': 'f035d0badcmsh0995c28f91284e7p19cd9bjsn51a45c35f6cf'
    }
    const baseUrl = 'https://coinranking1.p.rapidapi.com'

    const createRequest = (url) => ({url, headers: cryptoApiHeaders})
  
  
    export const cryptoApi = createApi({
        reducerPath: 'cryptoApi',
        baseQuery: fetchBaseQuery({baseUrl}),
        endpoints: (builder) => ({
            getCryptos: builder.query({
                query: (count) => createRequest(`/coins?limit=${count}`)
            }),
            getCryptoDetail: builder.query({
                query: (coinId) => createRequest(`/coin/${coinId}`)
            }),
            getCryptoHistory: builder.query({
                query: ({coinId, timePeriod}) => createRequest(`/coin/${coinId}/history/${timePeriod}`)
            }),
            getExchanges: builder.query({
                query: () => createRequest(`/exchanges`)
            })
        })
    });
    export const {
        useGetCryptosQuery, useGetCryptoDetailQuery, useGetCryptoHistoryQuery, useGetExchangesQuery
    } = cryptoApi